import { useCallback, useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { compose, map, split, trim, allPass, all, not, isEmpty, nth, test } from "ramda";
import AddItemModal from "../settings/AddItemModal";
import { calcularPorcentajeAumento, convertToArrayObject, formatMoney, getPrecioVenta, getPrecioVentaByPorcentaje, getTotal, getUniqueId, isNilOrEmpty, normalizeMoney, optionsPorcentajes, roundValue, isCustomPorcentaje } from "../general/utils";
import styled from "@emotion/styled";
import { TableColumn } from "react-data-table-component";
import { MDBBtn, MDBIcon, MDBTooltip } from "mdb-react-ui-kit";
import DataTableCustom from "../general/DataTableCustom";
import SelectCustom from "../general/SelectCustom";
import { useSettingsStore } from "../../store/settingsStore";
import AlertMessage, { IAlertMessage } from "../general/alertMessage";

import Loading from "../general/loading";
import { PrecioVentaInput } from "./PrecioVentaInput";
import { DescripcionInput } from "./DescripcionInput";

const StyledBoxCopyPaste = styled.div`
    padding: 90px 0px;
    background-color: #eee;
`

interface IProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  typeAction: {typeName?: string, option?: string, data?: any }
  handleSave: any;
}

type DataRow = {
  medioLabel: string;
  conceptoLabel: string;
  descripcion: string;
  cantidad: string;
  repeticion: string;
  precioUnitario: string;
};

const format = compose(map(compose(map(trim), split("\t"))), split(/(?:\r\n|\r|\n)/), trim)

const moneyRegex = /^\$?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/

const moneyValidation = (value: any) => !isNilOrEmpty(value) && test(moneyRegex, value);

const getCantidad = nth(0)
const getRepeticion = nth(1)
const getPrecioUnitario = nth(2)
const getPorcentaje = nth(3)

const validateCantidad = all(compose(not, isEmpty, getCantidad))
const validateRepeticion = all(compose(not, isEmpty, getRepeticion))
const validatePrecioUnitario = all(compose(moneyValidation, getPrecioUnitario))
const validatePorcentaje = all(compose(not, isEmpty, getPorcentaje))

const validateArray = [validateCantidad, validateRepeticion, validatePrecioUnitario, validatePorcentaje]

const AddImportarServiciosForm = ({showModal = false, setShowModal, typeAction, handleSave }: IProps) => {
  const { getProyectosServer } = useSettingsStore()

  const [currentPage, setCurrentPage] = useState(1)
  const [rows, setRows] = useState(15)

  const [arrayData, setArrayData] = useState<any[]>([])
  const [errorImportData, setErrorImportData] = useState(false);
  const [loading, setLoading] = useState(false)
   const [saving, setSaving] = useState(false)
  const [alert, setAlert] = useState<IAlertMessage | null>(null)
console.log("arrayData >>> ", arrayData)
  const getProyectosData = useCallback(async() => {
    getProyectosServer()
  }, [getProyectosServer])

  useEffect(() => {
    getProyectosData()
  }, [getProyectosData])

  const updateRow = (row: any, updates: any) => {
    setArrayData((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, ...updates } : item
      )
    )
  }

  const onChangePrecioVenta = (value: string, row: any) => {
    const porcentajeCalculado = roundValue(
      calcularPorcentajeAumento(
        Number(row.precioUnitario),
        Number(value)
      )
    )

    updateRow(row, {
      precioVenta: value,
      porcentajeCalculado,
    })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columnsCopy: any[] = [
    {
      id: "cantidad",
      name: "Cantidad",
    },
    {
      id: "repeticion",
      name: "Repeticion",
    },
    {
      id: "precioUnitario",
      name: "P.U. Costo",
      format: (value: string) => normalizeMoney(value),
    },
    {
      id: "porcentaje",
      name: "Porcentaje",
      // format: (value: string) => { 
      //   console.log("PP > ", value) 
      //   return parseInt(value)/100 
      // },
    },
    {
      id: "descripcion",
      name: "Descripcion",
    },
  ]

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns: TableColumn<DataRow>[] = [
    {
      id: "medio",
      name: "Medio",
      cell: (row: any) => {
        const {optionsMedios} = typeAction.data
        const {medio = "" } = row

        return (
          <div style={{width: "160px"}}>
            <SelectCustom options={optionsMedios} onChangeSelect={(data: any) => onChangeSelect(data, row) } name='medio' hiddeLabel={true} defaultValue={medio} required /> 
          </div> 
        )
      },
      sortable: false,
      minWidth: "170px",
    },
    {
      id: "conceptoLabel",
      name: "Concepto",
      cell: (row: any) => {
        const {concepto="", conceptosOptions=[]} = row
        
        return (
          <div style={{width: "160px"}}>
            <SelectCustom options={conceptosOptions} onChangeSelect={(data: any) => onChangeSelect(data, row) } name='concepto' hiddeLabel={true} defaultValue={concepto} required /> 
          </div> 
        )
      },
      sortable: false,
      minWidth: "170px",
    },
    {
      id: "descripcion",
      name: "Descripcion",
      cell: (row: any) => (
        <DescripcionInput
          row={row}
          onCommit={(value: any) =>
            updateRow(row, { descripcion: value })
          }
        />
      ),
      sortable: false,
      minWidth: "150px",
    },
    {
        id: "cantidad",
        name: "Cantidad",
        selector: (row: { cantidad: any; }) => row.cantidad,
        sortable: true
    },
    {
      id: "repeticion",
      name: "Repeticion",
      selector: (row: { repeticion: any; }) => row.repeticion,
      sortable: true
    },
    {
      id: "precioUnitario",
      name: "P.U. Costo",
      selector: (row: { precioUnitario: any; }) => formatMoney(row.precioUnitario),
      sortable: true
    },
    {
        id: "total",
        name: "Total",
        cell: (row: any) => {
          const {cantidad, repeticion, precioUnitario} = row

          const monto = cantidad * repeticion * precioUnitario
          return <NumericFormat displayType="text" value={formatMoney(monto) } prefix="$" thousandSeparator="," decimalScale={2}  />
        },
        sortable: true
    },
    {
      id: "porcentaje",
      name: "Porcentaje",
      cell: (row: any) => {
        const isCustom = isCustomPorcentaje(row.porcentaje)

        if (isCustom) {
          const porcentajeCalculado = roundValue(
            calcularPorcentajeAumento(
              Number(row.precioUnitario),
              Number(row.precioVenta)
            )
          )

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span className="fw-bold">{porcentajeCalculado}%</span>

              <MDBIcon
                fas
                icon="undo"
                size="sm"
                title="Regresar a porcentaje fijo"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  onChangeSelect(
                    { name: "porcentaje", value: "30", label: "30%" },
                    row
                  )
                }
              />
            </div>
          )
        }

        return (
          <SelectCustom
            options={optionsPorcentajes}
            onChangeSelect={(data: any) => onChangeSelect(data, row)}
            name="porcentaje"
            hiddeLabel
            defaultValue={row.porcentaje}
            required
          />
        )
      },
      minWidth: "130px",
    },
    {
      id: "precioVenta",
      name: "P.U. Venta",
      cell: (row: any) => {
        const isCustom = isCustomPorcentaje(row.porcentaje)

        return isCustom ? (
          <PrecioVentaInput
            row={row}
            onCommit={(value) => onChangePrecioVenta(value, row)}
          />
        ) : (
          <NumericFormat
            displayType="text"
            value={formatMoney(row.precioVenta)}
            prefix="$"
            thousandSeparator=","
            decimalScale={2}
          />
        )
      },
    },
    {
      id: "totalVenta",
      name: "Total Venta",
      cell: (row: any) => {
        const {cantidad, repeticion, precioVenta} = row
        return <NumericFormat displayType="text" value={getTotal(cantidad, repeticion, precioVenta)} prefix="$" thousandSeparator="," decimalScale={2}  />
      },
      sortable: true
    },
  ];
  const actionsDataTable = (data: any) => {
    return (
      <div className="w-100 d-flex flex-row align-items-center justify-content-end" >

        {alert && data.id === alert.index && 
          <MDBTooltip tag='a' wrapperProps={{ href: '#' }} title="Hay datos pendientes por seleccionar">
            <MDBIcon fas icon='exclamation-circle' size='sm' className="me-2" style={{color: "red"}} />
          </MDBTooltip>}  
  
        <MDBBtn tag='a' color='none' style={{ color: '#3b5998' }} onClick={() => {}} >
          <MDBIcon fas icon='trash' size='sm' />
        </MDBBtn>
      </div>
    )
  }
  const columnAction = [
    {
        name: "",
        width: "25px",
        button: true,
        cell: (row: any) => actionsDataTable(row),
        right: true,
    }
  ]
    
  const importFromClipboard = useCallback(
    async (e: { clipboardData: { getData: (arg0: string) => any; }; }) => {
      setLoading(true)
      setErrorImportData(false);
      let pastedItems

      if (e.clipboardData?.getData) {
        pastedItems = e.clipboardData.getData("text")
      } else if (window.navigator.clipboard?.readText) {
        pastedItems = await window.navigator.clipboard.readText()
      }

      const formattedEntities = format(pastedItems)
      const validate = allPass([ ...validateArray]) //  length,

      const setExtraData = (row: any) => {
        // const precio = parseFloat(row.precioUnitario);
        // console.log("Extra-row: ", row)
        return {
          porcentajeLabel: `${row.porcentaje}%`,
          precioVenta: getPrecioVenta(row.precioUnitario, parseInt(row.porcentaje)/100),
          id: getUniqueId(),
        };
      };

      if (validate(formattedEntities)) {
          const newArrayData = convertToArrayObject(formattedEntities, columnsCopy, setExtraData)
          
          setArrayData(newArrayData)
      } else {
          setErrorImportData(true);
      }
      setLoading(false)
    },
    [columnsCopy, setLoading],
  )

  const handleSaveData = async () => {
    const normalizedData = arrayData.map(row => ({
      ...row,
      porcentaje:
        row.porcentaje === "-1"
          ? roundValue(row.porcentajeCalculado)
          : row.porcentaje,
    }))

    setSaving(true)
    await handleSave("Nuevo", normalizedData)
    setSaving(false)
    setShowModal(false)
  }

  useEffect(() => {
      const handlePasteAction = (e:any) => {
        importFromClipboard(e)
      }
  
      window.addEventListener("paste", handlePasteAction)
  
      return () => {
        window.removeEventListener("paste", handlePasteAction)
      }
  }, [importFromClipboard])

  const onChangeSelect = (data: any, row: any) => {
    const { value, label, name } = data

    let updates: any = {
      [name]: value,
      [`${name}Label`]: label,
    }

    if (name === "porcentaje") {
      Object.assign(
        updates,
        getPrecioVentaByPorcentaje(
          row.precioUnitario, // Number()
          value
        )
      )
    }

    if (data?.dataObject?.conceptos) {
      updates.conceptosOptions = data.dataObject.conceptos
      updates.concepto = ""
      updates.conceptoLabel = ""
    }

    updateRow(row, updates)
  }

  const ImportData = () => {
    return (
      <>
        <div className="text-start">
            <h6>Copiar y Pegar 3 columnas el siguiente Orden: 
              <span className="fw-bold"> Cantidad, Repeticion, P.U. Costo, Porcentaje, Descripcion </span> 
            </h6>
            <h6 className="bold"> Example: <span className="fw-bold">1, 4, 102.50, 30, "Premios de canje"</span></h6>
        </div>
        <StyledBoxCopyPaste className="square border w-100 d-inline-block">
            Pegar 5 columnas (CTRL/CMD+V)
        </StyledBoxCopyPaste>
      </>)
    }

    const DisplayData = () => {
      return (
        <>
          <DataTableCustom
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            rowsPerPage={rows}
            setRowsPerPage={setRows}        
            keyDataTable="table-servicios" 
            columns={[ ...columnAction, ...columns]} 
            data={arrayData} />
        </>
      )
    }

    const constentForm = () => {
      return (
        <>          
          { loading 
            ? <Loading />
            : arrayData.length 
              ? <DisplayData />
              : <ImportData />
          }

          {errorImportData && 
            <div className='w-100'>
              <AlertMessage 
                offAutoClose={true} 
                alert={{
                  type: "danger",
                  title: "Error", 
                  message: "Los datos a importar no cuenta con la estructura necesaria, es necesario revisarlos y volverlo a intentar",
                }} 
                setAlert={() => setErrorImportData(false) } />
            </div> }
        </>    
      )
    }

  const reviewSaveButtonStatus = () => {
    if (!arrayData.length) return false

    // Revisar que todos tengan medio y concepto
    const isValid = arrayData.every(
      (item) => item.medio && item.concepto
    )

    return isValid
  }

  return (
      <AddItemModal
        keyModal="modal-lineadenegocio"
        sizeModa="xl"
        alert={alert}
        typeAction={typeAction}
        showModal={showModal}
        setShowModal={setShowModal}
        handleSave={handleSaveData}
        disabledSaveButton={!reviewSaveButtonStatus()}
        saving={saving}
      >
        { constentForm() }
      </AddItemModal>
    )
}

export default AddImportarServiciosForm
